/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages               
      },
      finalize: function() {
          
        $('.dropdown-toggle').dropdown();
        
        /*
        $('#js-navbar-collapse').on('shown.bs.collapse', function () {
                $("header").addClass("push-header-toright");
                $("body").addClass("cbp-spmenu-push");
                $(".search-form").hide();
            });
            
        $('#js-navbar-collapse').on('hide.bs.collapse', function () {
                $("header").removeClass("push-header-toright");
                $("body").removeClass("cbp-spmenu-push"); 
                $(".search-form").show();
        }); 
          /*
           * 
           * 
           */
          
          $("#showLeftPush, #showLeftPushB").on('click', function() {
                $( this ).toggleClass('active' ); 
                $( 'body' ).toggleClass( 'cbp-spmenu-push-toright' );
                $("#cbp-spmenu-s1").toggleClass( 'cbp-spmenu-open' );
                $("#navbar-close, #navbar-hamburger").toggleClass( 'hidden' );
                
	
        });
           
       $(".in-mobile").on('click', function() {           
           $(".search-form label").toggle();
       });

      }
    },
    // Home page
    'home': {
      init: function() {
       
         var swiperHome = new Swiper('.swiper-container', {           
            paginationClickable: false,           
            preloadImages: false,           
            lazyLoading: true
        });
        
        $(".iconografia ul li").on("mouseover", function(e) {           
            if ( $( this ).hasClass("active")  === true )  { return false; }
            
                var classname = $( this ).attr("class");
                $(".iconografia >ul").attr("class", "list-unstyled " + classname);             
        });
        
        $(".iconografia ul li").on("mouseout", function(e) { 
                      
           if ( $(".iconografia ul li").hasClass("active") ) {              
               var classname = $(".iconografia ul li.active").attr("class");
               $(".iconografia >ul").attr("class", "list-unstyled " + classname);
               $(".iconografia >ul").removeClass("active");
           }else {
               $(".iconografia >ul").attr("class", "list-unstyled ");
           }
       
            
        });
        
        $(".iconografia ul li").on("click", function(e) {
            e.preventDefault();
            
            $(".iconografia ul li").removeClass("active");                        
                        
            var classname = $( this ).attr("class");
            $( this ).addClass("active");
            
            $(".iconografia-content").removeClass('move');  
                 
            $(".iconografia-content." + classname).addClass("move");
            
        });
        
        $(".iconografia-content.ponmetro").addClass("move");
        
        
                                          
         $(".map-area").on("click", function(e){                                  
            e.preventDefault();  
          
          /*
            if(e.isTrigger !== 3) {
                   var target = $("#anchor-info-map");  

                   $('html, body').stop().animate({
                     scrollTop: target.offset().top - 90
                   }, 1000);
               }                        
            */         
            $('.info').removeClass('move');                      
            
            var info_id = $( this ).attr('alt');            
            $( "#" + info_id ).addClass('move');
                                           
            $(".map-area").data('maphilight', {alwaysOn: false}).trigger('alwaysOn.maphilight');
            
            $(this).data('maphilight', {alwaysOn: true}).trigger('alwaysOn.maphilight');
            

            
        });
                    
          
	$('#social-stream').dcSocialStream({
		feeds: {
			twitter: {
				id: '@ponmetro1420',
                                url: mainjs.template_url + '/assets/vendor/jquery.social.stream/twitter.php',
                                retweets: true
			},
                        youtube: {
				id: 'UCskkO9XwCXUgfYYIJd5iycw',
                                api_key: 'AIzaSyARcggCdmzkvv07UsnZwHGkabfr7WY9QVI'
			},
            instagram: {
                id: '!4158311737',
				accessToken: '4158311737.281945f.171e3f4f43bf43edb3e874e0a3877859', //'4158311737.281945f.c6a8b2cf42564f3cb645a725061aa537',
				clientId: '281945f9c0804160992f68794875f970'
			},
            },
            rotate: {
			delay: 0
		},
        twitterId: '@Open_LAquila',
        control: false,
		filter: false,
		wall: true,
		cache: false,
        center: true,
        limit: 3,
        days: 120,
		max: 'limit',
        order: 'date',
        iconPath: mainjs.template_url + '/assets/vendor/jquery.social.stream/images/dcsns-dark/',
		imagePath: mainjs.template_url + '/assets/vendor/jquery.social.stream/images/dcsns-light-1/',               
	});
            
      },
      finalize: function() {
          
          
            /*$('img[usemap]').mapTrifecta({
                 zoom: false,
                 table: false,
                 stroke:false,
                 fillColor: 'f9b700',
                 fillOpacity: 0.5,
                 shadow: false,    

            });*/
            
            $( "#map-start" ).click();
            
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }   
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
